<template>
    <svg viewBox="0 0 53.333 53.333">
        <path clip-rule="evenodd" d="M53.333 26.667C53.333 11.937 41.396 0 26.667 0 11.937 0 0 11.937 0 26.667c0 14.729 11.937 26.666 26.667 26.666.156 0 .312 0 .469-.01V32.572h-5.73v-6.676h5.73v-4.917c0-5.698 3.479-8.802 8.561-8.802 2.439 0 4.532.176 5.136.26v5.959h-3.5c-2.76 0-3.302 1.312-3.302 3.24v4.25h6.614l-.864 6.677h-5.75V52.3c11.146-3.197 19.302-13.457 19.302-25.634z"/>
    </svg>
</template>

<script>
export default {}
</script>
